import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { EditorInputField } from '../../../editor-container/editor-model';

@Component({
  selector: 'kve-toggle',
  templateUrl: './toggle.component.html',
  styleUrls: ['./toggle.component.scss']
})
export class ToggleComponent implements OnChanges{
  checked:boolean;
  label:string;
  trueValue:any;
  falseValue:any;
  @Input()field:EditorInputField;
  options:any[];

  @Output() updateField: EventEmitter<any> = new EventEmitter<any>();

  ngOnChanges(changes: SimpleChanges): void {
    if(changes["field"]){
      console.log(this.field)
      if(this.field.context != undefined && this.field.context != null){
        if(this.field.context["options"] != undefined){
          this.options = this.field.context["options"];
          let trueValueOption = this.options.find(option => option["checked"] == true);
          this.trueValue = trueValueOption["value"];
          let falseValueOption = this.options.find(option => option["checked"] == false);
          this.falseValue = falseValueOption["value"]
          if(this.field.value == trueValueOption["value"]){
            this.checked = true;
          }else{
            this.checked = false;
          }
        }
      }
      //this.checked = this.field.value?this.field.value:false;
      if(this.field.title != undefined){
        this.label = this.field.title;
      }else if(this.field.context != undefined && this.field.context != null){
        this.label = this.field.context.label;
      }else{
        this.label = this.field.name;
      }
      //this.label = this.field?.context.label?this.field.context.label:this.field.name;
    }
  }

  onToggle(e){
    console.log(e);
    if(e === true){
      this.field.value = this.trueValue;
      /* if(this.options != undefined){
        let optionField = this.options.find(option => option["checked"] == true);
        this.field.value = optionField["value"];
      } */
    }else if(e === false){
      this.field.value = this.falseValue;
      /* if(this.options != undefined){
        let optionField = this.options.find(option => option["checked"] == false);
        this.field.value = optionField["value"];
      } */
    }else{
      this.field.value = e;
    }
    console.log(this.field);
    this.updateField.emit(this.field);
  }

}
